var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    { attrs: { bus: _vm.busModal, "max-width": "900px" } },
    [
      _c("Title", { attrs: { title: "Pesquisar simulação" } }),
      _c(
        "div",
        [
          _c(
            "form",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "input-group align-items-center my-5 mr-5" },
                [
                  _c("v-text-field", {
                    staticClass: "input short-search",
                    attrs: {
                      "append-icon": " ",
                      "background-color": "#E4E0E6",
                      label: "",
                      "full-width": "",
                      placeholder: "Pesquisar"
                    },
                    model: {
                      value: _vm.searchSimulacao,
                      callback: function($$v) {
                        _vm.searchSimulacao = $$v
                      },
                      expression: "searchSimulacao"
                    }
                  }),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-icon btn-icon-secondary align-self-center",
                      style: {
                        "background-color": "#E4E0E6"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "19.276",
                            height: "19.966",
                            viewBox: "0 0 19.276 19.966"
                          }
                        },
                        [
                          _c("path", {
                            staticClass: "fill",
                            attrs: {
                              d:
                                "M19.967 18.186l-4.752-4.942a8.058 8.058 0 1 0-6.17 2.879 7.975 7.975 0 0 0 4.618-1.459l4.788 4.98a1.051 1.051 0 1 0 1.516-1.458zM9.045 2.1a5.958 5.958 0 1 1-5.958 5.961A5.965 5.965 0 0 1 9.045 2.1z",
                              transform: "translate(-.984)"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c("v-data-table", {
            staticClass: "tabela-simulacoes-pesquisa",
            attrs: {
              headers: _vm.headers,
              items: _vm.simulacoes,
              height: "300",
              search: _vm.searchSimulacao,
              loading: _vm.loading,
              "fixed-header": ""
            },
            on: { "click:row": _vm.selectSimulacao },
            scopedSlots: _vm._u([
              {
                key: "item.nome_simulacao",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("strong", [
                      _vm._v(" " + _vm._s(item.nome_simulacao) + " ")
                    ])
                  ]
                }
              },
              {
                key: "item.actions",
                fn: function() {
                  return [
                    _c(
                      "v-btn",
                      { attrs: { text: "", icon: "", small: "" } },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-chevron-right",
                            color: "#8E8E8E",
                            size: "16"
                          }
                        })
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }